import utils from '../utils/utils'
import anime from '../libs/anime'
import globalVar from '../utils/globalVar'

class ScrollAnimation {
  constructor() {
    let cache = {};
    let scrollPos = window.pageYOffset;
    let initFunc = () => {
      initCache();
      registerEvents();
      scrollDetect();
    }

    let initCache = () => {

      cache.header = document.querySelector('header');
      cache.sections = document.querySelectorAll('section');

      if(document.querySelector('.template-single-case-studies .hero_info')) {
        cache.caseHeroInfo = document.querySelector('.template-single-case-studies .hero_info');
        cache.caseHeroInfoImg = cache.caseHeroInfo.querySelector('.img');
        cache.caseHeroInfoTxt = cache.caseHeroInfo.querySelector('.info');
        if((scrollPos + window.innerHeight - 120) > (cache.caseHeroInfo.offsetTop + cache.caseHeroInfo.offsetHeight)) {
            anime({
                targets: cache.caseHeroInfoImg,
                scale: 1,
                duration: 300,
                easing: 'linear',
            });
            anime({
                targets: cache.caseHeroInfoTxt,
                opacity: 1,
                duration: 300,
                easing: 'linear',
            });
        }
      }
      if(document.querySelector('.module-01_hero.type_hero-home .fade')) {
        cache.heroFade = document.querySelectorAll('.module-01_hero.type_hero-home');
      }
      if(document.querySelector('.module-01_hero.type_hero2, .module-01_hero.type_hero3.hero_line, .template-archive')) {
        cache.heroLine = document.querySelectorAll('.module-01_hero.type_hero2, .module-01_hero.hero_line, .template-archive');
      }

      // ANIME CLASS
      if(document.querySelector('.anime-txt')) {
        cache.animeTxt = document.querySelectorAll('.anime-txt');
      }
      if(document.querySelector('.anime-title')) {
        cache.animeTitle = document.querySelectorAll('.anime-title');
      }
      if(document.querySelector('.anime-play')) {
        cache.animePlay = document.querySelectorAll('.anime-play');
      }
      if(document.querySelector('.anime-cards')) {
        cache.animeCards= document.querySelectorAll('.anime-cards');
      }


      // HERO ANIME
      if(document.querySelector('.module-01_hero.type_hero-home')) {
        cache.hero1 = document.querySelector('.module-01_hero.type_hero-home');
        animeHero1();
      }
      if(document.querySelector('.module-01_hero.type_hero2')) {
        cache.hero2 = document.querySelector('.module-01_hero.type_hero2');
        animeHero2();
      }
      if(document.querySelector('.module-01_hero.type_hero3')) {
        cache.hero3 = document.querySelector('.module-01_hero.type_hero3');
        animeHero3();
      }
      if(document.querySelector('.module-hero-case')) {
        cache.heroCase = document.querySelector('.module-hero-case');
        animeHeroCase();
      }
    };

    let registerEvents = () => {
      window.addEventListener('scroll', scrollDetect);
      anime({
        targets: document.querySelector('body'),
        opacity: [0, 1],
        duration: 500,
        easing: 'easeOutQuad',
      });
    };

    let animeHero1 = () => {
      const logo = cache.hero1.querySelector(".logo");
      const txt = cache.hero1.querySelector(".txt");
      const title = cache.hero1.querySelector(".title-h1");
      const btn = cache.hero1.querySelector(".btn_wrap");
      const scroll = cache.hero1.querySelector(".scroll");
      
      if(logo) {
        anime({
          targets: logo,
          translateY: ['-50%','-50%'],
          translateX: ['-50%','-50%'],
          scale: [0.8, 1],
          opacity: [0,1],
          duration: 600,
          easing: 'easeOutQuad'
        });
      }

      if(title) {
        anime({
          targets: title,
          opacity: [0,1],
          translateY: ['150%', '0%'],
          skewY: [5,0],
          delay: 600,
          duration: 600,
          easing: 'easeOutQuad',
        });
      }

      if(txt) {
        anime({
          targets: txt,
          opacity: [0,1],
          translateY: ['40%', '0%'],
          skewX: [-2,0],
          duration: 600,
          delay: 900,
          easing: 'easeOutQuad',
        });
      }

      if(btn) {
        anime({
          targets: btn,
          opacity: [0,1],
          translateY: ['40%', '0%'],
          delay: 1200,
          duration: 600,
          easing: 'easeOutQuad',
        });
      }

      if(scroll) {
        anime({
          targets: scroll,
          opacity: [0,1],
          translateX: ['-50%', '-50%'],
          translateY: ['40%', '0%'],
          delay: 1200,
          duration: 600,
          easing: 'easeOutQuad',
        });
      }

    };

    let animeHero2 = () => {
      const icon = cache.hero2.querySelector(".icon video");
      const title1 = cache.hero2.querySelector(".title_inner1");
      const title2 = cache.hero2.querySelector(".title_inner2");

      if(title1) {
        anime({
          targets: title1,
          opacity: [0,1],
          translateY: ['150%', '0%'],
          skewY: [8,0],
          duration: 600,
          easing: 'easeOutQuad',
        });
      }

      if(icon) {
        anime({
          targets: icon,
          opacity: [0,1],
          delay: 300,
          duration: 300,
          easing: 'easeOutQuad',
          complete: function() {
            icon.play(); 
          }
        });
      }

      if(title2) {
        anime({
          targets: title2,
          opacity: [0,1],
          translateY: ['150%', '0%'],
          skewY: [8,0],
          delay: 400,
          duration: 600,
          easing: 'easeOutQuad',
        });
      }
    };

    let animeHero3 = () => {
      const img = cache.hero3.querySelector(".img");
      const title = cache.hero3.querySelector(".title_wrap");
      const txt = cache.hero3.querySelector(".txt");
      const btn = cache.hero3.querySelector(".btn_wrap");
      if(title) {
        anime({
          targets: title,
          opacity: [0,1],
          translateY: ['150%', '0%'],
          skewY: [4,0],
          duration: 600,
          easing: 'easeOutQuad',
        });
      }

      if(txt) {
        anime({
          targets: txt,
          opacity: [0,1],
          translateY: ['40%', '0%'],
          skewX: [-2,0],
          duration: 600,
          delay: 300,
          easing: 'easeOutQuad',
        });
      }

      if(btn) {
        anime({
          targets: btn,
          opacity: [0,1],
          translateY: ['40%', '0%'],
          delay: 600,
          duration: 600,
          easing: 'easeOutQuad',
        });
      }

      if(img) {
        anime({
          targets: img,
          opacity: [0,1],
          duration: 300,
          delay: 600,
          easing: 'easeOutQuad',
          complete: function() {
            if(img.querySelector('video')) {
              img.querySelector('video').play();
            }
          }
        });
      }
    };

    let animeHeroCase = () => {
      const icon = cache.heroCase.querySelector(".icon");
      const title = cache.heroCase.querySelector(".title_wrap");
      const txt = cache.heroCase.querySelector(".txt");
      const btn = cache.heroCase.querySelector(".btn_wrap");
      if(title) {
        anime({
          targets: title,
          opacity: [0,1],
          translateY: ['150%', '0%'],
          skewY: [4,0],
          duration: 600,
          easing: 'easeOutQuad',
        });
      }

      if(txt) {
        anime({
          targets: txt,
          opacity: [0,1],
          translateY: ['40%', '0%'],
          skewX: [-2,0],
          duration: 600,
          delay: 300,
          easing: 'easeOutQuad',
        });
      }

      if(btn) {
        anime({
          targets: btn,
          opacity: [0,1],
          translateY: ['40%', '0%'],
          delay: 600,
          duration: 600,
          easing: 'easeOutQuad',
        });
      }

      if(icon) {
        anime({
          targets: icon,
          opacity: [0,1],
          duration: 300,
          delay: 600,
          easing: 'easeOutQuad',
          complete: function() {
            if(icon.querySelector('video')) {
              icon.querySelector('video').play();
            }
          }
        });
      }
    };

    let scrollDetect = function() {
      let up = false;
      if(scrollPos > window.pageYOffset) {
        up = true;
      }
      scrollPos = window.pageYOffset;


// NAV
      if(!up && (scrollPos > window.innerHeight) && !cache.header.classList.contains('up')) {
        document.querySelector('body').classList.add('up');
        cache.header.classList.add('up');
        anime({
          targets: cache.header,
          translateY: ['0%', '-100%'],
          duration: 500,
          easing: 'easeOutQuad'
        });
      } else if(up && (scrollPos > window.innerHeight) && cache.header.classList.contains('up')) {
        document.querySelector('body').classList.remove('up');
        cache.header.classList.remove('up');
        anime({
          targets: cache.header,
          translateY: ['-100%', '0%'],
          duration: 500,
          easing: 'easeOutQuad',
        });
      }

      for (let i = 0; i < cache.sections.length; i++) {
        if((scrollPos+50) > cache.sections[i].offsetTop && scrollPos < (cache.sections[i].offsetTop+cache.sections[i].offsetHeight)) {
          if(cache.sections[i].classList.contains('header_white') && !cache.header.classList.contains('white')) {
            cache.header.classList.add('white');
          }
          if(cache.sections[i].classList.contains('header_black') && cache.header.classList.contains('white')) {
            cache.header.classList.remove('white');
          }
        }
      }


// SINGLE CASE STUDY HERO INFO 
      if(cache.caseHeroInfo && globalVar.desktop.matches) {
        if( ((scrollPos + (window.innerHeight/2)+cache.header.offsetHeight) > cache.caseHeroInfo.offsetTop) && ((scrollPos + window.innerHeight - 120) < (cache.caseHeroInfo.offsetTop + cache.caseHeroInfo.offsetHeight))) {
            let pos = ( ((scrollPos + (window.innerHeight/2)+cache.header.offsetHeight) - cache.caseHeroInfo.offsetTop) / (cache.caseHeroInfo.offsetHeight-cache.caseHeroInfo.offsetTop+ (window.innerHeight/2)));

            const animCaseHeroInfo =  anime({
                targets: cache.caseHeroInfoImg,
                scale: [0.45, 1],
                duration: 1000,
                easing: 'easeInSine',
                autoplay: false,
            });

            const animCaseHeroInfoTxt =  anime({
                targets: cache.caseHeroInfoTxt,
                opacity: [0, 1],
                translateY: ['-100%','0%'],
                delay: 600,
                duration: 1000,
                easing: 'linear',
                autoplay: false,
            });

            animCaseHeroInfo.seek(pos * animCaseHeroInfo.duration);
            animCaseHeroInfoTxt.seek(pos * animCaseHeroInfoTxt.duration);
          }
        }


// HERO HOME FADE
        if(document.querySelector('.module-01_hero.type_hero-home .fade')) {
          cache.heroFade.forEach(hero => {
            if((scrollPos > hero.offsetTop) && (scrollPos < hero.offsetTop+hero.offsetHeight)) {
              let pos = (scrollPos - (hero.offsetTop))/(hero.offsetHeight);
              const fade = hero.querySelector('.fade');

              let animeFade = anime({
                targets: fade,
                translateY: ['25%', '0%'],
                duration: 1000,
                easing: 'linear',
                autoplay: false,
              })

              animeFade.seek(pos * animeFade.duration);
            }
          });
        }

// HERO LINE
        if(document.querySelector('.module-01_hero.type_hero2, .module-01_hero.type_hero3.hero_line, .template-archive')) {
          cache.heroLine.forEach(hero => {
            if((scrollPos > hero.offsetTop) && (scrollPos < hero.offsetTop+hero.querySelector('.inner').offsetHeight)) {
              if((hero.classList.contains('completedUp'))) {
                hero.classList.remove('completedUp');
              }
              if((hero.classList.contains('completed'))) {
                hero.classList.remove('completed');
              }
              let pos = (scrollPos - (hero.offsetTop))/(hero.querySelector('.inner').offsetHeight);
              const lines = hero.querySelectorAll('.line');
              let ii = 0;
              for (let i = lines.length-1; i >= 0; i--) {
                const line = lines[i];
                const height = line.offsetHeight;
                let lineInnerAnime =  anime({
                    targets: line.querySelector('.line-inner'),
                    opacity: [1,0],
                    height: [height,0],
                    delay: 100 * ii,
                    duration: 1000,
                    easing: 'linear',
                    autoplay: false,
                    complete: function() {
                      if(i == 0) {
                        hero.classList.add('completed');
                      }
                  }
                }) 

                lineInnerAnime.seek((pos *(1.2 + i/10)) * lineInnerAnime.duration);
                ii++;
              }

            }

            if((scrollPos < hero.offsetTop-50) && (!hero.classList.contains('completedUp'))) {
              if((hero.classList.contains('completed'))) {
                hero.classList.remove('completed');
              }
              const lines = hero.querySelectorAll('.line');
              hero.classList.add('completedUp');
              lines.forEach(line => {
                const height = line.offsetHeight;
                anime({
                  targets: line.querySelector('.line-inner'),
                  opacity: 1,
                  height: height,
                  duration: 400,
                  easing: 'linear',
                }) 
              });
            }

            if((!hero.classList.contains('completed')) && (scrollPos > hero.offsetTop+hero.querySelector('.inner').offsetHeight)) {
              if((hero.classList.contains('completedUp'))) {
                hero.classList.remove('completedUp');
              }
              const lines = hero.querySelectorAll('.line');
              hero.classList.add('completed');
              lines.forEach(line => {
                const height = line.offsetHeight;
                anime({
                  targets: line.querySelector('.line-inner'),
                  opacity: 0,
                  height: 0,
                  duration: 400,
                  easing: 'linear',
                }) 
              });
            }
          });

        }


  // ANIME CLASS
        if(document.querySelector('.anime-txt')) {
          cache.animeTxt.forEach(el => {
            const top = utils.getOffsetTop(el);
            if((scrollPos > (top-window.innerHeight)) && (scrollPos < top + (window.innerHeight/2))) {
              let pos = (scrollPos - (top-window.innerHeight))/(window.innerHeight/2);
              let animeTxt =  anime({
                    targets: el,
                    opacity: [0,1],
                    translateY: ['40%', '0%'],
                    skewX: [-2,0],
                    duration: 1000,
                    easing: 'easeOutSine',
                    autoplay: false,
                }) 

                animeTxt.seek((pos + 0.01) * animeTxt.duration);
              }
          });
        }

        if(document.querySelector('.anime-title')) {
          cache.animeTitle.forEach(el => {
            const top = utils.getOffsetTop(el);
            if((scrollPos > (top-window.innerHeight)) && (scrollPos < top + (window.innerHeight/2))) {
              let pos = (scrollPos - (top-window.innerHeight))/(window.innerHeight/2);
              let animeTxt =  anime({
                    targets: el,
                    opacity: [0,1],
                    translateY: ['80%', '0%'],
                    skewX: [-2,0],
                    duration: 1000,
                    easing: 'easeOutSine',
                    autoplay: false,
                }) 

                animeTxt.seek((pos + 0.01) * animeTxt.duration);
              }
          });
        }

        if(document.querySelector('.anime-play')) {
          cache.animePlay.forEach(el => {
            const top = utils.getOffsetTop(el);
            const height = el.parentNode.offsetHeight;
            if(((scrollPos+(window.innerHeight/2)) > top) && (scrollPos < (top + height)) && (!el.classList.contains('animated'))) {
              el.classList.add('animated');
              el.play();  
            }
            if((((scrollPos+(window.innerHeight)) < top) && (el.classList.contains('animated'))) || ((scrollPos > (top + height)) && (el.classList.contains('animated')))) {
              el.classList.remove('animated');
              el.currentTime = 0;
            }
          });
        }

        if(document.querySelector('.anime-cards')) {
          cache.animeCards.forEach(container => {
           const cards = container.querySelectorAll('.anime-cards_item');
            for (let i = 0; i < cards.length; i++) {
              const card = cards[i];
              const top = utils.getOffsetTop(container);
              if((scrollPos > (top-(window.innerHeight/1.5))) && (scrollPos < top + (window.innerHeight/2))) {
                let pos = (scrollPos - (top-(window.innerHeight/1.5)))/(window.innerHeight/2);
                let animeCard =  anime({
                      targets: card,
                      opacity: [0,1],
                      translateY: ['80%', '0%'],
                      skewX: [-2,0],
                      delay: (500 * i),
                      duration: (1000 + (500 * i)),
                      easing: 'easeOutSine',
                      autoplay: false,
                  }) 
                  const percent = (((pos + 0.01) * animeCard.duration)/(animeCard.duration+(500 * i)))
                  if(percent > 0.6 && card.querySelector('video')) {
                    const video = card.querySelector('video');
                      if(!video.classList.contains('animated')) {
                        video.play();
                        video.classList.add('animated');
                      }
                  }
                  animeCard.seek((pos + 0.01) * animeCard.duration);
              }
            }
          });
        }

    }

    initFunc();
  };
}
export { ScrollAnimation }
